import React from 'react';
import { Box, Typography, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';

/**
 * FBL Prime plans (2026-09-24) — display mirror of manijment-api's
 * services/primeTiers.js. The backend re-checks the plan, its price and the
 * order minimum on every order, so these numbers only drive what agents SEE.
 * Keep in sync if the plans change.
 */
export const PRIME_TIERS = [
  { key: 'silver',  label: 'Silver',  name: 'FBL Prime Silver',  price: 250,  monthlyFreeMrp: 1500,  minOrder: 5000 },
  { key: 'gold',    label: 'Gold',    name: 'FBL Prime Gold',    price: 500,  monthlyFreeMrp: 2500,  minOrder: 10000 },
  { key: 'diamond', label: 'Diamond', name: 'FBL Prime Diamond', price: 1500, monthlyFreeMrp: 10000, minOrder: 50000 },
];
export const getPrimeTier = key => PRIME_TIERS.find(t => t.key === key) || null;
export const primeTierPrice = key => (getPrimeTier(key) || {}).price || 0;
// Plans an order of this products subtotal can carry.
export const purchasablePrimeTiers = total => PRIME_TIERS.filter(t => Number(total || 0) >= t.minOrder);
export const LOWEST_PRIME_MIN_ORDER = Math.min(...PRIME_TIERS.map(t => t.minOrder));

const inr = n => '₹' + Math.round(n || 0).toLocaleString('en-IN');

// Silver can only be sold by typing "FBL Prime Silver Membership" into the
// uploaded sheet — never picked from the CRM list (Shailendra, 2026-09-25).
export const SHEET_ONLY_PRIME_TIERS = ['silver'];
// Plans the CRM list may offer for this order (Silver only if the sheet asked).
export const sellablePrimeTiers = (total, sheetTier = null) => purchasablePrimeTiers(total)
  .filter(t => !SHEET_ONLY_PRIME_TIERS.includes(t.key) || t.key === sheetTier);

/**
 * "Sell FBL Prime with this order" — shows only the plans whose minimum this
 * order's products subtotal reaches (₹10k → Gold; ₹50k → Gold/Diamond).
 * Silver appears only when the sheet itself asked for it (`sheetTier`).
 * `value` is the chosen plan key or null (not selling).
 */
export default function PrimePlanSelector({ orderTotal, value, onChange, sheetTier = null }) {
  const options = sellablePrimeTiers(orderTotal, sheetTier);
  if (!options.length) return null;
  return (
    <Box style={{
      margin: '0 0 12px', padding: '8px 12px', borderRadius: 8,
      background: '#eef6ff', border: '1px solid #bbdefb',
    }}>
      <Typography style={{ fontSize: 13, fontWeight: 700 }}>
        Sell FBL Prime with this order (COD — activates once delivered)
      </Typography>
      <RadioGroup value={value || 'none'} onChange={e => onChange(e.target.value === 'none' ? null : e.target.value)}>
        <FormControlLabel
          value="none"
          control={<Radio size="small" color="primary" style={{ padding: '3px 6px' }} />}
          label={<Typography style={{ fontSize: 13 }}>Don't sell Prime</Typography>}
        />
        {options.map(t => (
          <FormControlLabel
            key={t.key}
            value={t.key}
            control={<Radio size="small" color="primary" style={{ padding: '3px 6px' }} />}
            label={
              <Typography style={{ fontSize: 13 }}>
                <b>{t.name}</b>{SHEET_ONLY_PRIME_TIERS.includes(t.key) ? ' (from sheet)' : ''} — +{inr(t.price)} · free products up to {inr(t.monthlyFreeMrp)} MRP / month on orders of {inr(t.minOrder)}+
              </Typography>
            }
          />
        ))}
      </RadioGroup>
    </Box>
  );
}
